import {DAG_I_MILLISEKUNDER} from "./common";

export const DAGER_UTGAR_SNART = 3;

export const getFakturaFilnavn = fakturanr => `Faktura-${fakturanr}.pdf`;

export const betalingsfristUtgarSnart = betalingsfrist => (
    betalingsfrist && (Date.now() + DAGER_UTGAR_SNART * DAG_I_MILLISEKUNDER) > betalingsfrist
);
